import { ReactNode } from "react";
import { SvgIcon } from "@mui/material";
import { CoreIconButton, CoreIconButtonProps } from "./Button";
import CaretDown from "../../images/caret-down.svg?react";
import CaretUp from "../../images/caret-up.svg?react";
import CaretRight from "../../images/caret-right.svg?react";

export type CoreExpandButtonProps = Omit<CoreIconButtonProps, "tooltip" | "onClick" | "onChange" | "children"> & {
	collapsedRight?: boolean;
	expanded: boolean;
	onChange: (newExpanded: boolean) => void;
	collapsedTooltip?: ReactNode;
	expandedTooltip?: ReactNode;
};

export default function CoreExpandButton({
	variant,
	collapsedRight = false,
	expanded,
	onChange,
	collapsedTooltip,
	expandedTooltip,
	...buttonProps
}: CoreExpandButtonProps) {
	let icon: ReactNode;
	if (expanded) {
		icon = <CaretUp />;
	} else if (collapsedRight) {
		icon = <CaretRight />;
	} else {
		icon = <CaretDown />;
	}
	return (
		<CoreIconButton
			{...({ variant, color: variant === "plain" ? "#4D4D4D" : undefined, ...buttonProps } as CoreIconButtonProps)}
			onClick={() => onChange(!expanded)}
			tooltip={expanded ? expandedTooltip : collapsedTooltip}
			aria-expanded={expanded}
		>
			<SvgIcon sx={{ fontSize: 18 }}>{icon}</SvgIcon>
		</CoreIconButton>
	);
}
